import { CircularProgress } from "@mui/material";
import { ReactNode } from "react";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { useBulkArchiveRelationError } from "@ryde/redux";
import {
  entitiesMappingIdsSelector,
  hasKeys,
  IRydeProcess,
  PLURAL_KEY,
  SINGLE_KEY,
} from "@ryde/shared";

import {
  BulkArchiveRelationErrorDisplayStyled,
  RelationRowsIds,
} from "../../../../dialogs";

export const ProcessErrorsArchiveRelation = (
  currentProcess: IRydeProcess,
): ReactNode => {
  const entitiesMap = useRecoilValue(entitiesMappingIdsSelector);
  const entity = entitiesMap.get(currentProcess?.entityId) ?? "unknown";
  const { isPending, relationErrors, relationErrorsForCsv } =
    useBulkArchiveRelationError({
      currentProcess,
      entity,
    });
  const { t } = useTranslation();

  if (isPending) {
    return (
      <div style={{ padding: "10px" }}>
        {t("ui.LOADING")}...
        <CircularProgress sx={{ ml: "6px" }} size={12} />
      </div>
    );
  }

  return (
    !isPending &&
    hasKeys(relationErrors) && (
      <BulkArchiveRelationErrorDisplayStyled>
        <table className="excel-table">
          <thead>
            <tr>
              <th>{t(`${entity}.${SINGLE_KEY}`)}</th>
              <th>{t("general.RELATION_ENTITY")}</th>
              <th>{t("general.RELATION_IDS")}</th>
            </tr>
          </thead>
          <tbody>
            {relationErrors.map((row, index) => {
              const isFirstRowForId =
                index === 0 ||
                relationErrors[index].id !== relationErrors[index - 1].id;

              return (
                <tr key={`${row.id}-${row.relation}`}>
                  {isFirstRowForId ? (
                    <td
                      rowSpan={
                        relationErrors.filter(item => item.id === row.id).length
                      }
                      className="id-cell"
                    >
                      {row.name || row.id}
                    </td>
                  ) : null}
                  <td>{t(`${row.relation}.${PLURAL_KEY}`)}</td>
                  <RelationRowsIds ids={row.ids} relation={row.relation} />
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="download-btn-container">
          <CSVLink
            data={relationErrorsForCsv}
            filename="bulk_archive_existing_relation.csv"
            className="download-btn"
            target="_blank"
          >
            {t(`general.EXPORT_CSV`)}
          </CSVLink>
        </div>
      </BulkArchiveRelationErrorDisplayStyled>
    )
  );
};
